import { events } from '../../../services/api.admin';
import { fetchTableData, refresh } from '../tables';
import {
    typeToHumanReadable,
    receiverFromType,
    apiDataToState,
    stateToApiData
} from '../../../selectors/admin/models/event.emails';
import { apiActionCreator } from '../../helpers';
import { reset } from '../forms';
import { MODELS } from '../../../constants/admin/settings';
import { openFlash } from '../flash';
import { filtersSelector } from '../../../selectors/admin/tables';

export function fetchEventEmails(eventId) {
    return (dispatch, getState) => {
        const filters = filtersSelector(getState(), { tableIndex: 0 });
        return fetchTableData(() => events.getEmails(eventId, filters.mailType), 'emails', {
        transformFunction: emails => {
            return emails.map(e => ({
                ...e,
                content: apiDataToState(e.content),
                humanType: typeToHumanReadable(e.type),
                receiver: receiverFromType(e.type)
            }));
        }
    })(dispatch, getState);
    };
}

export function saveEventEmail(data) {
    return dispatch => {
        apiActionCreator(
            dispatch,
            () => events.putEmail(data.id, data.eventId, { ...data, content: stateToApiData(data.content) }),
            () => {
                dispatch(openFlash('Email successfully updated.'));
                dispatch(reset(MODELS.EVENT_EMAIL));
                dispatch(refresh());
            }
        );
    };
}
